import consumer from './cable';

$(document).ready(() => {
  const $pendingExportRow = $('#pendingExport');
  if ($pendingExportRow.length <= 0) { return; }

  consumer.subscriptions.create(
    {channel: 'ExportChannel', company_id: $pendingExportRow.data('company-id')},
    {
      received(data) {
        const $dateCell = $('#pendingExport td').first();
        const $fileCell = $('#pendingExport td').last().find('a');

        if (data.status == 'success') {
          $dateCell.html(data.created_at)
          $fileCell.attr('href', data.export_url);
          $fileCell.removeClass('d-none');
          $fileCell[0].click();
        } else {
          $dateCell.html('Une erreur est survenue. Merci de réessayer ultérieurement.');
        }
      }
    }
  );
});
